// React
import React, { useState, useEffect } from "react";

// Libraries
import PropTypes from "prop-types";
import { Button, Icon } from "semantic-ui-react";

// Components
import Text from "@Components/Text";

// Styles
import styles from "./styles.module.css";

const InfoBox = ({
	title = "",
	withButton = false,
	buttonIcon = "",
	buttonOnClick,
	children,
	toggleable = false,
	defaultToggleOpen = true,
	disabled = false,
}) => {
	const [showChildren, setShowChildren] = useState(true);

	useEffect(() => {
		setShowChildren(defaultToggleOpen);
	}, []);

	const toggleHandler = () => {
		if (toggleable) setShowChildren(!showChildren);
	};

	return (
		<div className={`${styles.container} ${disabled ? styles.disabled : ""}`}>
			<div className={styles.titleRow} onClick={toggleHandler} role="button" tabIndex={0}>
				{toggleable ? (
					<Icon className={styles.toggleIcon} name={showChildren ? "angle up" : "angle down"} />
				) : (
					<div className={styles.buttonSpace} />
				)}
				<Text className={styles.titleText}>{title}</Text>
				{withButton ? (
					<Button className={styles.floatingButton} onClick={buttonOnClick}>
						<Icon className={styles.buttonIcon} name={buttonIcon} />
					</Button>
				) : (
					<div className={styles.buttonSpace} />
				)}
			</div>
			{showChildren && children}
		</div>
	);
};

InfoBox.propTypes = {
	title: PropTypes.string,
	withButton: PropTypes.bool,
	buttonIcon: PropTypes.string,
	buttonOnClick: PropTypes.func,
	children: PropTypes.node,
	toggleable: PropTypes.bool,
	defaultToggleOpen: PropTypes.bool,
	disabled: PropTypes.bool,
};
export default InfoBox;
